import OwnerBadge from "../../components/OwnerBadge";
import useCommentAuthor from "./hooks/useCommentAuthor";

const CommentAuthor = ({ comment }) => {
  const { author } = useCommentAuthor(comment);
  return <OwnerBadge user={author} />;
};

export default CommentAuthor;
